
import { useEffect } from 'react'

import { Flex, Box, Breadcrumb, BreadcrumbItem, BreadcrumbLink, useColorModeValue } from '@chakra-ui/react';
import { NavLink  as RouterLink } from 'react-router-dom';

import DataTable from 'views/privado/servicesTracking/webTracking/detalle/components/DataTable'; 

import { useHistory } from "react-router-dom";
import useAuthContext from "hooks/useAuthContext";

import { LAYOUT_PUBLICO, PATH_LOGIN, LAYOUT_PRIVADO, PATH_WEB_TRACKING, PATH_HOME } from "const/CommonConst";


export default function WebTrackingDetalle() {	
	useEffect(() => document.title = `Taurel - Servicios en Línea - Web Tracking detalle`,[]);
	
	const history = useHistory();

	const {isAuthenticate, checkExpired, logout} = useAuthContext();
  
	useEffect(async () => {
	  if (!isAuthenticate || await checkExpired()){
		  logout();
		  history.push(`${LAYOUT_PUBLICO}${PATH_LOGIN}`);
	  }
	}, []); 
	
	
	let secondaryText = useColorModeValue('gray.700', 'white');

	return (
		<Flex direction='column' pt={{ sm: '125px', lg: '75px' }}>			
			{/* <Box mb={{ sm: '8px', md: '0px' }}>
					<Breadcrumb>
						<BreadcrumbItem color={secondaryText} fontSize='sm' mb='5px'>
							<BreadcrumbLink as={RouterLink} to={`${LAYOUT_PRIVADO}${PATH_HOME}`} color={secondaryText}>
								Inicio
							</BreadcrumbLink>
						</BreadcrumbItem>
						<BreadcrumbItem color={secondaryText} fontSize='sm'>
							<BreadcrumbLink as={RouterLink} to={`${LAYOUT_PRIVADO}${PATH_WEB_TRACKING}`}  color={secondaryText}>
								Web Tracking
							</BreadcrumbLink>
						</BreadcrumbItem>
					</Breadcrumb>					
				</Box> */}
				<DataTable  />
		</Flex>
	);
}